import React from 'react';
import { Box, Button, IconButton, styled } from '@mui/material';
import { BaseModal, Form } from 'iron-forge-react-modules';
import { Close } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { AppEventSelectField } from '../../selectFields';
import * as dataService from './dataService';

const FormContainerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginTop: 24
}));


export interface IProps {
  orderId?: string;
  returnAuthorizationId?: string;

  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {

  const [
    resendEmail,
    resendEmailTuple
  ] = dataService.useResendEmail({
    id: props.orderId || props.returnAuthorizationId || ''
  });

  const { genController } = AppEventSelectField.genComponentAndControllerGenerator({
    orderId: props.orderId,
    returnAuthorizationId: props.returnAuthorizationId
  });
  const ControlledStoreSelectField = genController<{ appEvent: AppEventSelectField.IAppEvent | null; }>();


  const form = useForm<{ appEvent: AppEventSelectField.IAppEvent | null; }>({
    defaultValues: { appEvent: null }
  });

  async function processSubmit(data: { appEvent: AppEventSelectField.IAppEvent | null; }) {

    if (data.appEvent) {
      await resendEmail({ appEvent: data.appEvent });
      props.onClose();
    }

  }

  function handleClickCancel() {
    props.onClose();
  }

  const fnCloseButton: BaseModal.IProps['fnGenElTopCloseButton'] = ({ onClose }) => (
    <IconButton onClick={onClose}>
      <Close />
    </IconButton>
  );

  const loading = resendEmailTuple.loading;

  return (
    <BaseModal.FC
      isOpen
      fnGenElTopCloseButton={fnCloseButton}
      fnGenElCloseButton={fnCloseButton}>
      {() => (
        <Form.FC onSubmit={form.handleSubmit(processSubmit)}>
          <FormContainerBox>
            <ControlledStoreSelectField
              isDisabled={loading}
              label="App Event"
              formControl={form.control}
              fieldKey="appEvent"
              isRequired
            />
            <ButtonBox>
              <Button
                disabled={loading}
                variant="outlined"
                onClick={handleClickCancel}
                type="button">
                Cancel
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                type="submit">
                Resend
              </Button>
            </ButtonBox>
          </FormContainerBox>
        </Form.FC>
      )}
    </BaseModal.FC>
  );
};
